import { UploadArtwork } from "@design-lab/widgets/design-lab-upload-artwork";
import { WeaveDesignLab } from "@design-lab/features/weave-design-lab";
import { useShowWeaveDesignLab } from "@design-lab/shared/lib/config";

/**
 * Reusable component that conditionally renders WeaveDesignLab or UploadArtwork
 * based on the shouldShowWeaveDesignLab experiment
 */
export function UploadSection() {
  const shouldShowWeaveDesignLab = useShowWeaveDesignLab();

  if (shouldShowWeaveDesignLab) {
    return <WeaveDesignLab />;
  }

  return <UploadArtwork />;
}
